import React, { useCallback, useState } from 'react';
import AvatarIcon from '@hud/web-components/AvatarIcon/AvatarIcon';
import Menu, { CaretIcon } from '@hud/web-components/Menu/Menu';
import useAnalytics from '../../hooks/useAnalytics';
import { User } from '@auth0/auth0-react';
import styled from 'styled-components';
import { clickableMixin } from '@hud/web-components/theme/utils';
import { textSmallSemiBold } from '@hud/web-components/DesignSystem/Typography';

export interface AvatarMenuProps {
  user: User;
  onLogout: () => void;
  caret?: boolean;
}

export default function AvatarMenuItem({ user, onLogout, caret }: AvatarMenuProps) {
  const analytics = useAnalytics();
  const [opened, setOpened] = useState(false);

  const handleMenuToggle = useCallback(
    (value: boolean) => {
      setOpened(value);
      analytics.capture('avatar_menu_toggled', { toggle_value: value });
    },
    [analytics],
  );

  return (
    <Menu.Menu opened={opened} onChange={handleMenuToggle}>
      <Menu.Target>
        <Container>
          {user.picture && <AvatarIcon image={user.picture} />}
          <Name>{user.given_name || user.email}</Name>
          {caret ? <CaretIcon icon="designSystem.chevronDown" /> : null}
        </Container>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Item onClick={onLogout}>Logout</Menu.Item>
      </Menu.Dropdown>
    </Menu.Menu>
  );
}

const Container = styled.div`
  ${clickableMixin};

  ${textSmallSemiBold};
  color: var(--text-standard-secondary);

  padding: var(--space-100) var(--space-150);
  display: flex;
  align-items: center;
  gap: 6px;
`;

const Name = styled.div``;
